import { render } from "./AddToTrip.vue?vue&type=template&id=552d43da"
import script from "./AddToTrip.vue?vue&type=script&lang=js"
export * from "./AddToTrip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__